// Centralized Database Schema for Firebase Realtime Database
// Eliminates magic strings and provides a single source of truth for paths

export const DB_PATHS = {
    // Admin 
    ADMIN_USERS: 'Admin/users',
    ADMIN_SETTINGS: 'Admin/settings',
    ADMIN_PAYMENT_METHODS: 'Admin/paymentMethods',
    ADMIN_THEME_SETTINGS: 'Admin/themeSettings',
    COUPONS: 'Admin/Coupons',
    PRIVATE_COUPONS: 'Admin/PrivateCoupons',
    ARCHIVED_COUPONS: 'Admin/ArchivedCoupons',
    BANNERS: 'Admin/bannerHtml',
    POPUPS: 'Admin/carouselImages',
    SCRIPT_REQUESTS: 'ScriptRequests',
    
    // Core Data
    USERS: 'Users',
    PRODUCTS: 'Products',
    ORDERS: 'Order index',
    STATS: 'Stats',
    STATS_PRODUCT_SALES: 'Stats/ProductSales',
    TESTED_SITES: 'TestedSites',
    REFERRAL_CODES: 'referrals-codes',
    
    // Dynamic Path Builders
    user: (uid) => `Users/${uid}`,
    userOrders: (uid, orderId) => `Users/${uid}/Orders/${orderId}`,
    userRewardPoints: (uid) => `Users/${uid}/Reward Points`,
    userPointsHistory: (uid) => `Users/${uid}/pointsHistory`,
    userTotalOrders: (uid) => `Users/${uid}/Total order`,
    userTotalSpent: (uid) => `Users/${uid}/Total Spent`,
    userTotalSpentCanonical: (uid) => `Users/${uid}/TotalSpent`,
    userProductAccess: (uid) => `Users/${uid}/ProductAccess`,
    userNotifications: (uid) => `Users/${uid}/Notifications`,
    userNotification: (uid, notificationId) => `Users/${uid}/Notifications/${notificationId}`,
    userNotificationsMeta: (uid) => `Users/${uid}/NotificationsMeta`,
    
    order: (orderId) => `Order index/${orderId}`,
    
    adminUser: (uid) => `Admin/users/${uid}`,
    
    coupon: (code) => `Admin/Coupons/${code}`,
    privateCoupon: (code) => `Admin/PrivateCoupons/${code}`,
    archivedCoupon: (code) => `Admin/ArchivedCoupons/${code}`,
    userCoupons: (uid) => `Users/${uid}/Coupons`,
    userCoupon: (uid, code) => `Users/${uid}/Coupons/${code}`,
    paymentMethod: (id) => `Admin/paymentMethods/${id}`,
    
    referralCode: (code) => `referrals-codes/${code}`,
    testedSite: (id) => `TestedSites/${id}`
};
